import { CircularProgress } from "@mui/material"
import styles from './circularModalLoader.module.css'

const CircularModal = (props:any) => {
  return (
    <div className={styles["modal-overlay"]}>
      <CircularProgress size={100} thickness={props.thickness} sx={{color:"#c3af5b"}} style={{zIndex:-1}} />
    </div>
  )
}
  
export default CircularModal